const companyInfo = require('../companyInfo')

module.exports = companyInfo